// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__M7nu2","spin":"Spinner_spin__Fsnsy"};